<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuth } from '@/composables/useAuth'
import { useThreads } from '@/composables/useThreads'
import { useChat } from '@/composables/useChat'
import { ApiError } from '@/services/api'
import AppLayout from '@/components/layout/AppLayout.vue'
import LoginPage from '@/components/auth/LoginPage.vue'

const { showLoginPage, authChecked, checkAuth, handleAuthFailure } = useAuth()
const { refreshThreads, getStoredThreadId, newThread, threads } = useThreads()
const { openThread } = useChat()

onMounted(async () => {
  await checkAuth()
  if (!showLoginPage.value) {
    try {
      await refreshThreads()
    } catch (e) {
      if (e instanceof ApiError && e.status === 401) {
        handleAuthFailure()
      }
    }
    // Restore the conversation the user was last viewing and reconnect to any
    // run still in flight (so a mid-answer refresh resumes the working state).
    // Only restore it if it still exists server-side; a stale id (e.g. after the
    // DB was reset) would otherwise show as a phantom "Thread xxxxxxxx".
    const storedThreadId = getStoredThreadId()
    if (storedThreadId && threads.value.some(t => t.thread_id === storedThreadId)) {
      openThread(storedThreadId)
    } else if (storedThreadId) {
      newThread()
    }
  }
})
</script>

<template>
  <template v-if="authChecked">
    <LoginPage v-if="showLoginPage" />
    <AppLayout v-else />
  </template>
</template>
